/// <reference types="@angular/localize" />

import {
  provideHttpClient,
  withInterceptorsFromDi,
  HttpClient,
} from '@angular/common/http';
import {
  provideRouter,
  withPreloading,
  PreloadAllModules,
  RouterOutlet,
} from '@angular/router';
import { APP_ROUTES } from './app/routes/app.routes';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { isDevMode, importProvidersFrom } from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app/app.component';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from './environments/environment';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

if (
  ['localhost', '127.0.0.1'].includes(window.location.hostname) &&
  'serviceWorker' in navigator
) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister().then(() => {
        console.log('ServiceWorker unregistered');
      });
    }
  });
}
function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      CommonModule,
      RouterOutlet,
      MatSlideToggleModule,
      MatToolbarModule,
      NgbModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      NgxDaterangepickerMd.forRoot(),
    ),
    provideRouter(APP_ROUTES, withPreloading(PreloadAllModules)),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: isDevMode(),
      connectInZone: true,
    }),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: true,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
}).catch((err) => console.error(err));
